import React, { useState, useEffect } from 'react';

const EbookForm = ({ existingData, onSave, onCancel }) => {
  const [deskripsi, setDeskripsi] = useState('');
  const [file, setFile] = useState(null);

  useEffect(() => {
    const data = existingData || {};
    setDeskripsi(data.deskripsi || '');
    setFile(null); // Selalu reset pilihan file
  }, [existingData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!file && !existingData) {
        alert('File PDF wajib diunggah saat menambah data baru.');
        return;
    }

    const formData = new FormData();
    formData.append('deskripsi', deskripsi);
    if (file) {
      formData.append('file', file);
    }
    onSave(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="form-card">
        <div className="form-group">
            <label>Deskripsi</label>
            <textarea
                rows="4"
                value={deskripsi}
                onChange={(e) => setDeskripsi(e.target.value)}
                placeholder="Masukkan deskripsi singkat tentang isi e-book..."
                required
            />
        </div>
        <div className="form-group">
            <label>File E-Book (PDF)</label>
            <input 
                type="file" 
                onChange={(e) => setFile(e.target.files[0])} 
                accept="application/pdf" 
            />
            {existingData && existingData.file && <small>Kosongkan jika tidak ingin mengganti file.</small>}
        </div>
        
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #f0f0f0' }}>
            <button type="button" onClick={onCancel} className="btn-secondary">Batal</button>
            <button type="submit" className="btn-primary">Simpan</button>
        </div>
    </form>
  );
};

export default EbookForm;